import EventBus from '../../services/EventBus';
import store from '../../store';
import Amplitude from '../../plugins/Amplitude';

class ShopifyAdapterService {
  onPageLoad(type, callback) {
    EventBus.on('pageLoad.' + type, callback);
  }

  async emmitPageLoad() {
    // init shopify data
    await store.dispatch('shopify/init');

    const pageType = store.getters['shopify/page/type'];

    // console.log('pageType', pageType);
    EventBus.emit('pageLoad.' + pageType);

    Amplitude.init();
  }
}

export default new ShopifyAdapterService();
